import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import './MessageBox.scss'

export const MESSAGE_BOX_VARIANT_INFO = 'info'
export const MESSAGE_BOX_VARIANT_SUCCESS = 'success'
export const MESSAGE_BOX_VARIANT_WARNING = 'warning'
export const MESSAGE_BOX_VARIANT_DANGER = 'danger'
export const MESSAGE_BOX_VARIANT_TIP = 'tip'
export const MESSAGE_BOX_VARIANT_HELP = 'help'

export const MessageBox = ({
  children,
  className,
  title,
  variant,
  closeButton,
  closeButtonCallback,
  'data-mu-test': dataAttributeTest
}) => (
  <div
    className={classnames('c-message-box', className, {
      'c-message-box--info': variant === MESSAGE_BOX_VARIANT_INFO,
      'c-message-box--success': variant === MESSAGE_BOX_VARIANT_SUCCESS,
      'c-message-box--warning': variant === MESSAGE_BOX_VARIANT_WARNING,
      'c-message-box--danger': variant === MESSAGE_BOX_VARIANT_DANGER,
      'c-message-box--tip': variant === MESSAGE_BOX_VARIANT_TIP,
      'c-message-box--help': variant === MESSAGE_BOX_VARIANT_HELP,
      'c-message-box--has-close': closeButton
    })}
    data-mu-test={classnames('message-box', dataAttributeTest)}
  >
    {closeButton && (
      <button
        className='c-message-box__close-button'
        type='button'
        onClick={closeButtonCallback}
      />
    )}
    {title && <strong className='c-message-box__title'>{title}</strong>}
    <div className='c-message-box__content'>{children}</div>
  </div>
)

MessageBox.defaultProps = {
  title: '',
  titleClassName: '',
  closeButton: false,
  closeButtonCallback: () => {
    console.error(
      'Method Not Implemented, pass a closeButtonCallback function props'
    )
  }
}

MessageBox.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  title: PropTypes.node,
  variant: PropTypes.string,
  closeButton: PropTypes.bool,
  closeButtonCallback: PropTypes.func,
  /**
   * Additional values for data-attribute used for tests and tracking
   **/
  'data-mu-test': PropTypes.string
}
